(function (factory) {
    factory();
}(function () {
    
    ko.bindingHandlers.datepicker = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            //initialize datepicker with some optional options
            var options = allBindingsAccessor().datepickerOptions || {};
            $(element).datepicker(options);

            //handle the field changing
            ko.utils.registerEventHandler(element, "change", function () {
                var observable = valueAccessor();
                observable($(element).val());
            });

            //handle disposal (if KO removes by the template binding)
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).datepicker("destroy");
            });

        },
        update: function (element, valueAccessor) {
            var value = $(element).val();
            if (value === "")
                value = ko.utils.unwrapObservable(valueAccessor());

            var value = ko.utils.unwrapObservable(valueAccessor());

            if (value)
                $(element).datepicker("setDate", value);
        }
    };

    ko.bindingHandlers.colorPicker = {
        init: function (element, valueAccessor) {
            var value = valueAccessor();
            var inputColor = $(element);
            inputColor.val(ko.utils.unwrapObservable(value));

            if (!inputColor.data("sp")) {
                if (value.disabled && value.disabled.subscribe) {
                    value.disabled.subscribe(function (newValue) {
                        inputColor.spectrum(newValue ? "disable" : "enable");
                    });
                }
                if (value.enabled && value.enabled.subscribe) {
                    value.enabled.subscribe(function (newValue) {
                        inputColor.spectrum(newValue ? "enable" : "disable");
                    });
                }
                let disabled = false;
                if (value.enabled !== undefined) {
                    if (typeof value.enabled === "function") {
                        disabled = !value.enabled();
                    }
                    else {
                        disabled = !value.enabled;
                    }
                }
                else {
                    if (value.disabled !== undefined) {
                        if (typeof value.disabled === "function") {
                            disabled = value.disabled();
                        }
                        else {
                            disabled = value.disabled;
                        }
                    }
                }

                inputColor.spectrum({
                    preferredFormat: "hex",
                    type: value.type ?? "color",
                    hideAfterPaletteSelect: value.hideAfterPaletteSelect ?? "true",
                    showInitial: value.showInitial ?? true,
                    showAlpha: value.showInitial ?? false,
                    allowEmpty: value.allowEmpty ?? true,
                    showInput: value.showInput ?? true,
                    disabled: disabled,
                    appendTo: !inputColor.data("appendto") ? "body" : inputColor.data("appendto"),
                    change: function (color) {
                        var observable = value.value ?? value;

                        if (color)
                            observable(color.toHexString());
                        else
                            observable("");
                    }
                });
            }
            inputColor.data("sp", true);
        },
        update: function (element, valueAccessor, allBindings) {
            var inputColor = $(element);
            var valueAcessor = valueAccessor();

            if (valueAcessor.value) {
                valueAcessor = valueAcessor.value;
            }

            var value = ko.utils.unwrapObservable(valueAcessor);

            inputColor.spectrum("set", value);
            inputColor.val(value);
        }
    }

    ko.bindingHandlers.selectPickerDateOption = {
        init: function (element, valueAccessor) {
            var value = valueAccessor();
            var select = $(element);
            select.selectpicker("render");
            select.selectpicker('val', value());
        },
        update: function (element, valueAccessor) {
            var select = $(element);
            var value = ko.utils.unwrapObservable(valueAccessor());
            select.prop('disabled', ko.contextFor(element).$data.dateOption() !== "Predefined");

            if (ko.contextFor(element).$data.dateOption() !== "Predefined")
                select.selectpicker('hide');
            else
                select.selectpicker('show');

            select.selectpicker("refresh");
        }
    }

    ko.bindingHandlers.numericValue = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            let underlyingObservable = valueAccessor();
            let interceptor = ko.dependentObservable({
                read: underlyingObservable,
                write: function (value) {
                    if (!isNaN(value)) {
                        underlyingObservable(parseFloat(value));
                    }
                }
            });
            ko.bindingHandlers.value.init(element, function () { return interceptor }, allBindingsAccessor);
        },
        update: ko.bindingHandlers.value.update
    };

    ko.subscribable.fn.subscribeChanged = function (callback) {
        var oldValue;
        this.subscribe(function (_oldValue) {
            oldValue = _oldValue;
        }, this, 'beforeChange');

        this.subscribe(function (newValue) {
            callback(newValue, oldValue);
        });
    };

    //Used on reportDesigner once but change to use the above function
    //if (!ko.subscribable.fn.subscribeChanged)
            //    ko.subscribable.fn.subscribeChanged = function (callback, context) {
            //        var savedValue = this.peek();
            //        return this.subscribe(function (latestValue) {
            //            var oldValue = savedValue;
            //            savedValue = latestValue;
            //            callback.call(context, latestValue, oldValue);
            //        });
            //    };
}));
